import React, {Component} from 'react';

class ContainerView extends Component {
    render() {
        return (
            <div>
                <div className="app-content">
                    <div className="app-content-body">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default ContainerView;


// WEBPACK FOOTER //
// ./src/views/Container/index.js